/**
 * Bloco 2 — State machine formal do Behavior.
 * Transições válidas evitam eventos duplicados e estados inconsistentes.
 */

import { BehaviorPhase } from './types';

const VALID_TRANSITIONS: Partial<Record<BehaviorPhase, BehaviorPhase[]>> = {
  [BehaviorPhase.ACTIVE]: [
    BehaviorPhase.IDLE,
    BehaviorPhase.HIDDEN,
    BehaviorPhase.EXITING,
  ],
  [BehaviorPhase.IDLE]: [BehaviorPhase.ACTIVE],
  [BehaviorPhase.HIDDEN]: [BehaviorPhase.ACTIVE],
  [BehaviorPhase.EXITING]: [],
};

export class BehaviorStateMachine {
  private _currentState: BehaviorPhase = BehaviorPhase.ACTIVE;
  private _listeners: Array<(from: BehaviorPhase, to: BehaviorPhase) => void> =
    [];

  get currentState(): BehaviorPhase {
    return this._currentState;
  }

  /** Só transiciona se for transição válida. */
  transition(to: BehaviorPhase): boolean {
    const allowed = VALID_TRANSITIONS[this._currentState];
    if (!allowed || !allowed.includes(to)) {
      if (
        typeof window !== 'undefined' &&
        (window as unknown as { __behaviorDebug?: boolean }).__behaviorDebug
      ) {
        console.warn(
          `[BehaviorStateMachine] Transição inválida: ${this._currentState} → ${to}`
        );
      }
      return false;
    }
    const from = this._currentState;
    this._currentState = to;
    this._listeners.forEach(fn => fn(from, to));
    return true;
  }

  onTransition(
    fn: (from: BehaviorPhase, to: BehaviorPhase) => void
  ): () => void {
    this._listeners.push(fn);
    return () => {
      this._listeners = this._listeners.filter(f => f !== fn);
    };
  }

  reset(): void {
    this._currentState = BehaviorPhase.ACTIVE;
  }
}

let defaultInstance: BehaviorStateMachine | null = null;

export function getBehaviorStateMachine(): BehaviorStateMachine {
  if (!defaultInstance) defaultInstance = new BehaviorStateMachine();
  return defaultInstance;
}

export function resetBehaviorStateMachine(): void {
  if (defaultInstance) defaultInstance.reset();
}
